import { taskSlaGroupApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TASKS_SLA_GROUP_ACTION_TYPE = createNamedActions('tasksSlaGroup', {
  GET_TASK_SLA_GROUP: 'GET_TASK_SLA_GROUP',
  GET_TASK_SLA_GROUPS_BY_APPLICATION_ID: 'GET_TASK_SLA_GROUPS_BY_APPLICATION_ID',
});

const taskSlaGroups = new schema.Entity('taskSlaGroups', {}, { idAttribute: 'id' });

export const getTaskSlaGroupAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await taskSlaGroupApi.getTaskSlaGroup(params);

  return dispatch({
    type: TASKS_SLA_GROUP_ACTION_TYPE.GET_TASK_SLA_GROUP,
    payload: data,
  });
});

export const getTaskSlaGroupsByApplicationIdAction = catchAsyncActionError(
  params => async dispatch => {
    const { data } = await taskSlaGroupApi.getTaskSlaGroupsByApplicationId(params);

    return dispatch({
      type: TASKS_SLA_GROUP_ACTION_TYPE.GET_TASK_SLA_GROUPS_BY_APPLICATION_ID,
      payload: normalize(data, [taskSlaGroups]).entities.taskSlaGroups,
    });
  },
);
